export default __webpack_public_path__ + "static/media/girl.cf8bd91e.jpg";